/*
Base class for all analytics Vendor APIs, in the form required for react-metrics

Vendor APIs should entend this and provide the following methods
  constructor(options), where options is the relevant configuration from config.js
  isSetUp(), which should return a boolean indicating if the vendors 3rd party code is set up and ready
  sendTracking(name, params, options), which delegates to the vendors own tracking call. All params come via the map
    name is the event name
    params is an object of the key/value pairs to send
    options is additional static data directly from the map
and optionally
  transformParams(params, map): Takes the params from the element, and transforms them according to the provided map
    This is likely to be unique per vendor, but analyticsUtils provides 3 useful helpers.

*/
import AnalyticsEventMap from 'utils/AnalyticsEventMap';
import { transformPlainParams } from 'utils/AnalyticsUtils';

export default class AnalyticsApi {
  constructor(name, vendorId, options = {}) {
    this.name = name;
    this.vendorId = vendorId;
    this.options = options;
  }

  pageView(name, args) {
    const path = window.location.pathname.substr(1);
    args.pageUrl = window.location.href;

    if (path.substr(0, 14) !== "error/500/from") {
      return this.track(name, args);
    }
  }

  user(userId) {
    return new Promise(resolve => {
      this.userId = userId;
      resolve({
        userId
      });
    });
  }

  eventMapConfig(eventName, args) {
    const {
      [eventName]: {
        [this.vendorId]: eventMapConfig
      } = {}
    } = AnalyticsEventMap;

    if (eventMapConfig) {
      const {
        name = eventName,
        options = {},
        paramMap = {}
      } = eventMapConfig;

      return {
        name,
        options,
        params: this.transformParams(args, paramMap)
      };
    }
  }

  transformParams(...params) {
    return transformPlainParams(...params);
  }

  track(eventName, args) {
    if (this.isSetUp()) {
      const eventMapConfig = this.eventMapConfig(eventName, args);

      if (eventMapConfig) {
        const {
          name,
          params,
          options
        } = eventMapConfig;

        this.sendTracking(name, params, options);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./utils/AnalyticsApi.js